import { useEffect, useMemo, useState } from 'react';
import GridProvider from './components/GridProvider';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NewDocumentForm from './components/NewDocumentForm';
import MuiDialog from '../../../../../../UI/MuiDialog/MuiDialog';
import useHttp from '../../../../../../../hooks/use-http';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../../../../shared/api/handleErrorMessage';
import { formatDateToDB } from '../../../../../../../../utils/FormatDate';
import styles from './Documents.module.css';
import { getBaseUrl } from '../../../../../../../../utils/getUrl';
import axios from 'axios';
import LoaderProgress from '../../../../../PregledRadnogNaloga/Dnevnik/components/LoaderProgress';

const INITIAL_VALUES = {
  id: 0,
  nazivFajla: '',
  nazivJezika: '',
  idJezika: 0,
  nazivGlavnaKategorija: '',
  idGlavnaKategorija: 0,
  nazivKategorije: '',
};

const Documents = ({ idMasine, kategorija, idTipaMasine }) => {
  const { t, i18n } = useTranslation();
  const api = getBaseUrl();
  console.log(idTipaMasine);
  const {
    sendRequest: getGridData,
    data: gridData,
    isLoading: isLoadingGrid,
  } = useHttp('');
  const { sendRequest: getJezik, data: languageData } = useHttp('');
  const { sendRequest: getGlavnaKategorija, data: mainCategoryData } =
    useHttp('');
  const { getData } = useHttp('');

  const [openDocument, setOpenDocument] = useState(false);
  const [openNewDocument, setOpenNewDocument] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [documentId, setDocumentId] = useState(0);
  const [formData, setFormData] = useState(INITIAL_VALUES);
  const [file, setFile] = useState([]);
  const [openPath, setOpenPath] = useState(null);

  const vratiGrid = () => {
    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENTA,
      data: {
        idObjekta: idMasine,
        objekat: 'mas',
        kategorija: kategorija,
        metadata: i18n.language,
      },
    };
    getGridData(config);
  };

  useEffect(() => {
    const config = {
      url: urls.GET_JEZIK,
    };
    getJezik(config);
    const configMainCategory = {
      method: 'POST',
      url: urls.GET_MAIN_CATEGORY,
      data: {
        kategorija: kategorija,
        metadata: i18n.language,
        idTipaMasine: idTipaMasine,
      },
    };
    getGlavnaKategorija(configMainCategory);

    vratiGrid();
  }, []);

  const handleOpenFile = (item) => {
    setOpenPath(item.path);
    setOpenDocument(true);
  };
  const handleOpenNewDocument = () => {
    setFormData(INITIAL_VALUES);
    setOpenNewDocument(true);
  };
  const handleNovi = () => {
    setFormData(INITIAL_VALUES);
    setFile([]);
  };
  const handleSave = async () => {
    const fd = new FormData();
    if (formData.id) {
      fd.append('Id', formData.id);
    }
    fd.append('IdVrsteDokOpste', formData.idGlavnaKategorija);
    fd.append('objekat', 'mas');
    fd.append('IdObjekta', idMasine);
    fd.append('NazivFajla', formData.nazivFajla);
    fd.append('IdJezika', formData.idJezika);
    fd.append('Kategorija', formData.nazivKategorije);
    fd.append('Datum', formatDateToDB(new Date()));
    fd.append('IdKorProm', +localStorage.idKorisnika);
    fd.append('DokumentUrl', formData.url);
    if (file.length > 0) {
      if (formData.id) {
        // Dokument je za izmenu
        fd.append('Dokument', file[0]);
      } else {
        // Dokumenti je za unos
        fd.append('Dokumenti', file[0]);
      }
    }
    const config = {
      method: 'POST',
      url: formData.id ? urls.UPDATE_DOKUMENTA : urls.INSERT_DOKUMENTA,
      data: fd,
    };
    const result = await getData(config);
    if (result) {
      handleNovi();
      setOpenNewDocument(false);
      vratiGrid();
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setDocumentId(id);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: { id: documentId },
    };
    const result = await getData(config);
    if (result) {
      setDocumentId(0);
      setOpenDeleteDialog(false);
      vratiGrid();
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  // const downloadFile = async (fileUrl, fileName) => {
  //   const config = {
  //     method: 'POST',
  //     url: 'Dokumenta/konvertovanje_base64',
  //     data: { vrednost: fileUrl },
  //   };

  //   const response = await getData(config);

  //   const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

  //   // Konvertovanje base64 stringa u Blob objekt
  //   const byteCharacters = atob(base64Data);
  //   const byteNumbers = Array.from(byteCharacters, (char) =>
  //     char.charCodeAt(0),
  //   );
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: 'application/octet-stream' });

  //   // Kreiranje URL-a za Blob objekt
  //   const blobUrl = URL.createObjectURL(blob);

  //   // Kreiranje i klikanje na link element za preuzimanje datoteke
  //   const link = document.createElement('a');
  //   link.href = blobUrl;
  //   link.setAttribute('download', fileName); // Postavite naziv datoteke
  //   document.body.appendChild(link);
  //   link.click();

  //   // Čišćenje URL-a i uklanjanje linka
  //   URL.revokeObjectURL(blobUrl);
  //   document.body.removeChild(link);
  // };

  const [downloading, setDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const downloadFile = async (fileUrl, fileName) => {
    try {
      setDownloading(true);
      setDownloadProgress(0);

      const apiUrl = `${api}Dokumenta/konvertovanje_base64_download?url=${encodeURIComponent(
        fileUrl,
      )}`;

      const response = await axios.get(apiUrl, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          console.log(progressEvent);
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            setDownloadProgress(percent);
          }
        },
      });

      const blob = new Blob([response.data]);

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', fileName || '');

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download greška:', error);
    } finally {
      setDownloading(false);
      setDownloadProgress(0);
    }
  };
  const editFile = (item) => {
    //    id: 0,
    // nazivFajla: '',
    // nazivJezika: '',
    // idJezika: 0,
    // nazivGlavnaKategorija: '',
    // idGlavnaKategorija: 0,
    // nazivKategorije: '',
    handleOpenNewDocument();
    console.log(item);
    setFormData({
      id: item.id,
      objekat: 'mas',
      idGlavnaKategorija: item.idVrsteDokOpste,
      nazivFajla: item.nazivFajla,
      nazivJezika: item.nazivJezika,
      idJezika: item.idJezika,
      nazivKategorije: item.kategorija,
      nazivGlavnaKategorija: item.nazivVrsteDokOpste,
      url: item.path,
    });
  };

  const categories = useMemo(() => {
    const set = new Set(
      gridData.map((row) => row.nazivVrsteDokOpste).filter(Boolean),
    );
    return Array.from(set);
  }, [gridData]);

  return (
    <div style={{ marginBottom: '40px' }}>
      {downloading && <LoaderProgress progress={downloadProgress} />}
      {localStorage.idFirme === '1' && (
        <div
          style={{ cursor: 'pointer', width: 'fit-content' }}
          onClick={handleOpenNewDocument}
        >
          <i className="fas fa-plus-circle" /> {t('newDocument')}
        </div>
      )}
      <div style={{ marginTop: '5px' }}>
        {categories.map((category, idx) => {
          const filtered = gridData.filter(
            (row) => row.nazivVrsteDokOpste === category,
          );
          return (
            <Accordion
              key={idx}
              defaultExpanded={false}
              sx={{
                border: '1px solid #b8b8b8ff',
                borderRadius: '6px',
                mb: 0.2,
                boxShadow: 'none',
                '&:before': { display: 'none' }, // uklanja defaultnu liniju
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon fontSize="small" />}
                aria-controls={`panel${idx}-content`}
                id={`panel${idx}-header`}
              >
                <Typography
                  sx={{ fontSize: '14px', fontWeight: 600, color: '#000000ff' }}
                >
                  {category}{' '}
                  <span style={{ color: '#000000ff' }}>
                    ({filtered.length}{' '}
                    {filtered.length === 1 ? 'item' : 'items'})
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 1 }}>
                <GridProvider
                  data={filtered}
                  loading={isLoadingGrid}
                  handleOpenFile={handleOpenFile}
                  handleOpenDeleteDialog={handleOpenDeleteDialog}
                  downloadFile={downloadFile}
                  editFile={editFile}
                />
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>

      {/* <GridProvider
        data={gridData}
        loading={isLoadingGrid}
        handleOpenFile={handleOpenFile}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        downloadFile={downloadFile}
        editFile={editFile}
      /> */}
      <MuiDialog
        maxWidth="md"
        open={openDocument}
        title="DOCUMENT"
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openNewDocument}
        title={t('newDocument')}
        content={
          <NewDocumentForm
            formData={formData}
            setFormData={setFormData}
            languageData={languageData}
            mainCategoryData={mainCategoryData}
            setFile={setFile}
            file={file}
          />
        }
        handleClose={() => setOpenNewDocument(false)}
        handleConfirm={handleSave}
        deniedText={t('close')}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Documents;
